module.exports = __webpack_public_path__ + "imgs/shop.80c993605830164be130d8cd068280a4.svg";